import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
// import Paper from '@mui/material/Paper'
// import { styled } from '@mui/material/styles'
import WTypography from '../../../Components/whiteTypography'
import TabList from '@mui/lab/TabList'
import './style.css'
import { makeGetRequest } from 'utils/api'
import { Box, Container, Tab, useMediaQuery, useTheme } from '@mui/material'
import { TabContext, TabPanel } from '@mui/lab'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
const PlantDetail = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const siteUser = useSelector((store) => store.user)
  const [infoshow, setInfoShow] = useState(true)

  const [value, setValue] = React.useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const { id } = useParams()
  const [plant, setPlant] = useState({})
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])
  useEffect(() => {
    makeGetRequest('/api/garden/dashboard-Myplant/' + id, {}, true)
      .then((response) => {
        setPlant(response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [id])

  if (!plant.Nom) {
    return <div>Loading...</div>
  }

  return (
    <Container maxWidth="lg">
      {/* <Box className="marge"> */}
      <Box className="" px={isMobile ? 1 : 2}>
        <Box fontSize={isMobile ? '80%' : '100%'} textAlign={isMobile ? 'center' : 'unset'}>
          <span className="PlantTitel">
            {plant.Nom.Nom} - {plant.Nom.Surnom}
          </span>
          <span className="subtitelGreyText"> {plant.Nom.Surnom} </span>
        </Box>
        {/* <Box className="header1"> */}
        <Box
          className=""
          mt={2}
          display={'flex'}
          flexDirection={isMobile ? 'column' : 'row'}
          gap={2}
          // justifyContent={'space-between'}
        >
          <Box width={'100%'}>
            <Box
              height={250}
              // width={200}
              overflow={'hidden'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              width="100%"
            >
              <img src={plant.Nom.Logo} alt="Logo" />
            </Box>
          </Box>
          <Box width={'100%'} sx={{ display: infoshow ? 'block' : 'none' }}>
            <div className="espacement">
              <span className="field">Ordres :</span>
              <a href={plant.Nom.Famille.linksOrder} className="value">
                {plant.Nom.Famille.Order}
              </a>
            </div>
            <div className="espacement">
              <span className="field">Famille :</span>
              <a href={plant.Nom.Famille.linksFamily} className="value">
                {plant.Nom.Famille.Famille}
              </a>
            </div>
            <div className="espacement">
              <span className="field">Type de plante :</span>
              <span className="value">{plant.Nom.Surnom}</span>
            </div>
          </Box>
          <Box width={'100%'} sx={{ display: infoshow ? 'block' : 'none' }}>
            <div className="espacement">
              <span className="field">Climat :</span>
              <span className="value">{plant.Nom.Climat}</span>
            </div>
            <div className="espacement">
              <span className="field">Température :</span>
              <span className="value">
                {plant.Nom.MiniTemp}°C - {plant.Nom.Temperature}°C
              </span>
            </div>
            <div className="espacement">
              <span className="field">Exposition :</span>
              <span className="value">{plant.Nom.exposure}</span>
            </div>
          </Box>
        </Box>
        <Box display={'flex'} justifyContent={'center'} mt={1}>
          {isMobile && (
            <>
              {infoshow ? (
                <KeyboardArrowUpIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              )}
            </>
          )}
        </Box>
        <div>
          <Box sx={{ width: '100%', typography: 'body1', color: 'white' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  onChange={handleChange}
                  textColor="inherit"
                  sx={{ '.MuiTabs-flexContainer': { overflow: 'auto' } }}
                >
                  <Tab label="Informations générales" value="1" />
                  <Tab label="Arrosage" value="2" />
                  <Tab label="Taille / Tuteurage" value="3" />
                  <Tab label="Engrais" value="4" />
                  <Tab label="Pantation / Multiplication" value="5" />
                  <Tab label="Rempotage" value="6" />
                  <Tab label="Association" value="7" />
                </TabList>
              </Box>
              <TabPanel value="1">
                <section>
                  <WTypography variant="h6">Informations générales</WTypography>

                  <p className="InfoGene">{plant.Nom.GeneralDesc}</p>
                </section>
              </TabPanel>
              <TabPanel value="2">
                <section>
                  <WTypography variant="h6">Arrosage</WTypography>

                  <Box
                    className="header1"
                    display={'flex'}
                    flexDirection={isMobile ? 'column' : 'row'}
                  >
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {plant.Nom.WateringSum} x/{plant.Nom.UnitWateSum}
                      </h6>
                      <p className="InfoGene">Arrosage été</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {plant.Nom.WateringWin} x/{plant.Nom.UnitWateWin}
                      </h6>
                      <p className="InfoGene">Arrosage hiver</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {convertToUserDateFormate(siteUser.user, plant.LastWat)}
                      </h6>
                      <p className="InfoGene">Dernier arrosage</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {convertToUserDateFormate(siteUser.user, plant.nextWat)}
                      </h6>
                      <p className="InfoGene">Prochain arrosage</p>
                    </div>
                  </Box>
                  <p className="InfoGene">{plant.Nom.WateComment}</p>
                </section>
              </TabPanel>
              <TabPanel value="3">
                <section>
                  <WTypography variant="h6">Tailles</WTypography>

                  <p className="InfoGene">{plant.Nom.PruningComment}</p>

                  <p className="InfoGene">{plant.Nom.tuteuragetxt}</p>
                </section>
              </TabPanel>
              <TabPanel value="4">
                <section>
                  <WTypography variant="h6">Engrais</WTypography>

                  <Box
                    className="header1"
                    display={'flex'}
                    flexDirection={isMobile ? 'column' : 'row'}
                  >
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {plant.Nom.FertilizerType ? plant.Nom.FertilizerType : '-'}
                      </h6>
                      <p className="InfoGene">Type d'engrais</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {plant.Nom.FertilizerFreq} x/{plant.Nom.UnitFertFreq}
                      </h6>
                      <p className="InfoGene">Fréquence</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {convertToUserDateFormate(siteUser.user, plant.LastFert)}
                      </h6>
                      <p className="InfoGene">Dernier apport</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {convertToUserDateFormate(siteUser.user, plant.nextFert)}
                      </h6>
                      <p className="InfoGene">Prochain apport</p>
                    </div>
                  </Box>
                </section>
              </TabPanel>
              <TabPanel value="5">
                <section>
                  <WTypography variant="h6">Plantation</WTypography>

                  <Box
                    className="header1"
                    display={'flex'}
                    flexDirection={isMobile ? 'column' : 'row'}
                  >
                    <div className="InfoGene2">
                      <h6 className="infoH6">{plant.Nom.semis ? plant.Nom.semis : '-'}</h6>
                      <p className="InfoGene">Semis</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">{plant.Nom.repiquage ? plant.Nom.repiquage : '-'}</h6>
                      <p className="InfoGene">Repiquage</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">{plant.Nom.Flowering ? plant.Nom.Flowering : '-'}</h6>
                      <p className="InfoGene">Floraison</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">{plant.Nom.recolte ? plant.Nom.recolte : '-'}</h6>
                      <p className="InfoGene">Récolte</p>
                    </div>
                  </Box>
                  <p className="InfoGene">{plant.Nom.CommentPlanting}</p>
                </section>
              </TabPanel>
              <TabPanel value="6">
                <section>
                  <WTypography variant="h6">Rempotage</WTypography>

                  <Box
                    className="header1"
                    display={'flex'}
                    flexDirection={isMobile ? 'column' : 'row'}
                  >
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {plant.Nom.FreqRempotage} x/ {plant.Nom.UnitGrownFreq}
                      </h6>
                      <p className="InfoGene">Fréquence</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {convertToUserDateFormate(siteUser.user, plant.LastRempot)}
                      </h6>
                      <p className="InfoGene">Dernier Rempotage</p>
                    </div>
                    <div className="InfoGene2">
                      <h6 className="infoH6">
                        {convertToUserDateFormate(siteUser.user, plant.nextRempot)}
                      </h6>
                      <p className="InfoGene">Prochain Rempotage</p>
                    </div>
                  </Box>
                  <p className="InfoGene">{plant.Nom.CommentCommentGrown}</p>
                </section>
              </TabPanel>
              <TabPanel value="7">
                <section>
                  <WTypography variant="h6">Association</WTypography>

                  <p className="InfoGene">{plant.Nom.Association}</p>
                </section>
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </Box>
    </Container>
  )
}

export default PlantDetail
